import type { FC } from 'react';
import { Flex, Icon, Typography } from '@ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ContactsCard } from '@/components/ContactsCard/ContactsCard';
import { GenericPageSectionWrapper } from '@/components/GenericPageSectionWrapper/GenericPageSectionWrapper';
import styles from './MailsSection.module.css';

export const MailsSection: FC = () => {
    const { t } = useTranslation();

    const items = useMemo(() => [
        {
            mail: 'events@vatsim-petersburg.com',
            icon: <Icon.Calendar />,
            description: t('Contacts_Emails_Events')
        },
        {
            mail: 'staff@vatsim-petersburg.com',
            icon: <Icon.Badge />,
            description: t('Contacts_Emails_Other')
        }
    ], [t]);

    return (
        <GenericPageSectionWrapper size="l">
            <Flex gap={80}>
                <Flex vertical justify="center" flex="0 0 auto" gap={24} className={styles.sectionTitle}>
                    <Typography.Heading level={5}>{t('Contacts_Emails_Subtitle')}</Typography.Heading>
                    <Typography.Paragraph>{t('Contacts_Emails_Subsubtitle')}</Typography.Paragraph>
                </Flex>
                {items.map(({ mail, icon, description }) => (
                    <ContactsCard
                        key={mail}
                        mail={mail}
                        icon={icon}
                        description={description}
                    />
                ))}
            </Flex>
        </GenericPageSectionWrapper>
    );
};
